<template>
	<section>
		<!--工具条(查询条件)-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
		</el-col>

		<!--列表(查询结果-当前页)-->
		<el-table :data="roles" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column prop="roleid" label="角色编号"  sortable>
			</el-table-column>
			<el-table-column prop="rolename" label="角色名称" sortable>
			</el-table-column>
			<el-table-column prop="addtime" label="创建时间"  sortable>
			</el-table-column>
			<el-table-column prop="remark" label="备注"  sortable>
			</el-table-column>

			<template>
				<el-table-column label="操作" width="170" fixed="right">
					<template scope="scope">
						<el-button size="small" @click="handleMore(scope.$index, scope.row)">详细</el-button>
						<el-button v-if="scope.row.roleid != 0" :plain="true" type="success" size="small" @click="handleEditRoleAuth(scope.$index, scope.row)">修改</el-button>					
					</template>
				</el-table-column>
			</template>

		</el-table>

		<!--工具条(分页)-->
		<el-col :span="24" class="toolbar">
			<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="currentPage"
			:page-sizes="[10, 20, 50, 100]"
			:page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total"
			style="float:right;">
			</el-pagination>
		</el-col>

		
		<!--修改权限-->
		<el-dialog title="修改权限" :visible.sync="editRoleAuthVisible"  :close-on-click-modal="false">
			<div class="el-dialog-div">
				<el-tree
					ref="tree"
					v-loading="resourceLoading"
					:data="editRoles"
					show-checkbox
					node-key="id"
					:default-expand-all=true
					:default-checked-keys="checkedKeys"
					:props="defaultProps">
				</el-tree>
			</div>
			<div slot="footer" class="dialog-footer" v-show="editRolefooter">
				<el-button @click.native="editRoleAuthVisible= false">取消</el-button>
				<el-button type="primary" @click.native="editRoleResourceSubmit" :loading="editLoading">保存</el-button>
			</div>
		</el-dialog>

    <!--查看权限-->
    <el-dialog title="查看权限" :visible.sync="showRoleAuthVisible" :close-on-click-modal="false">
			<div class="el-dialog-div">
				<el-tree
					:data="editRoles"
					v-loading="showRoleAuthLoading"
					show-checkbox
					node-key="id"
					:default-expand-all=true
					:default-checked-keys="checkedKeys"
					:props="defaultProps">
				</el-tree>
			</div>
		</el-dialog>


	</section>
</template>

<script>
	import util from '../../common/js/util'
	import constant from '../../common/js/constant'
	import { getRoleList, getResourceList, editRoleResource,getChecked} from '../../api/api';

	export default {
		data() {
			return {
				sysUserName: '',
				roleid:'',
				roles: [],
				total: 0,//列表总条数
				pageSize:10,//每页条数
				currentPage:1,//当前页码
				listLoading: false,
				resourceLoading: false,
				editRolefooter:false,
				showRoleAuthLoading:false,

				addLoading: false,
				editRoleAuthVisible: false,//修改界面是否显示
        showRoleAuthVisible: false,//查看界面是否显示
				editLoading: false,
				//单卡出库界面数据
				oneOutSkuForm: {
					cardno: '',
					serviceman: '',
					skuOutDate: new Date(),
					oneSkuNumTip:'',
					rechargePrice:''
				},
        checkedKeys:[],
				editRoles:[],
        defaultProps: {
          children: 'children',
          label: 'title',
          disabled:this.isDisabled
        }

			}
		},
		methods: {
			handleSizeChange(val) {
				this.pageSize = val;
				this.getRoles();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getRoles();
			},
      isDisabled(){
        if(this.showRoleAuthVisible == true){
          return true;
        }else{
          return false;
        }
      },
			
			//获取用户列表
			getRoles() {
				let para = {
					pageSize:this.pageSize,
					pageNum:this.currentPage			
				};

				this.listLoading = true;
				
				getRoleList(para).then((res) => {
					this.total = res.data.total;
					this.roles = res.data.list;
					this.listLoading = false;
				});
			},
			//显示查看权限界面
			handleMore: function (index, row) {
					this.showRoleAuthLoading = true;
          this.checkedKeys=[];
          this.editRoles=[];
          let params = {roleid :row.roleid};
          getChecked(params).then((res) => {
            if(res.code != '0'){
              alert('获取角色所拥有的菜单权限失败！');
              return;
            }
            this.checkedKeys=res.data;
            let para = {};
            //获取所有菜单
            getResourceList(para).then((res) => {
              this.editLoading = false;
              this.editRoles=res.data;
							this.showRoleAuthLoading = false;
            });
          });

          this.showRoleAuthVisible = true;
			},

			//显示修改权限界面
			handleEditRoleAuth: function (index, row) {
				this.resourceLoading = true;
				this.editRolefooter = false;
        this.checkedKeys=[];
        this.editRoles=[];
				this.roleid = row.roleid;
        let params = {roleid :row.roleid};
        getChecked(params).then((res) => {
          if(res.code != '0'){
            alert('获取角色所拥有的菜单权限失败！');
            return;
          }
          this.checkedKeys=res.data;
          let para = {};
          //获取所有菜单
          getResourceList(para).then((res) => {
            this.editLoading = false;
            this.editRoles=res.data;
						this.resourceLoading = false;
						this.editRolefooter = true;
          });
        });

				this.editRoleAuthVisible = true;
			},
			//修改角色菜单权限
			editRoleResourceSubmit: function () {
        // alert(this.$refs.tree.getCheckedKeys());
        // alert(this.$refs.tree.getHalfCheckedKeys());
				var residArr = [].concat(
						this.$refs.tree.getHalfCheckedKeys(), 
						this.$refs.tree.getCheckedKeys()
				)


				let msg = '确认提交吗？';
				if(residArr.length<=0){
						msg = '确认要清空该角色的菜单权限吗？';
				}
				let resids = residArr.join(',');
				//alert(resids);

				this.$confirm(msg, '提示', {}).then(() => {
					this.editLoading = true;

					let para = {};
					para.resids = resids;
					para.roleid = this.roleid;
					editRoleResource(para).then((res) => {
						this.editLoading = false;

						if(res.code == 0){
							this.$message({
								message: '修改成功',
								type: 'success'
							});
						}else{
							this.$message({
								message: '修改失败',
								type: 'error'
							});
						}
						
						this.editRoleAuthVisible = false;
						this.getRoles();
					});
				});

			}
		},
		mounted() {

			var user = sessionStorage.getItem('user');
			if (user) {
				user = JSON.parse(user);
				if(user.userlevel==0){
					this.sysUserName = '管理员';
				}else if(user.userlevel==1){
					this.sysUserName = '一级服务商';
				}else if(user.userlevel==2){
					this.sysUserName = '二级服务商';
				}
			}

			this.getRoles();
		}
	}

</script>

<style scoped>
.el-dialog-div{
    height: 60vh;
     overflow: auto;
    }
</style>


// WEBPACK FOOTER //
// set_rolemenu.vue?1d6c4758